import { useEffect } from 'react';
import { useTheme } from '../hooks/useTheme.ts';
import { ChallengeScreen } from './ChallengeScreen.tsx';
import { CreateScreen } from './CreateScreen.tsx';
import { parseRoute, usePath } from './router.ts';
import { ChallengeLayout, Notice, primaryButton } from './ui.tsx';

/** The /reto pages. */
export function ChallengeApp() {
  useTheme(null);
  const route = parseRoute(usePath());

  useEffect(() => {
    document.title =
      route.page === 'new' ? 'Crea un reto · Cruz de IA' : 'Reto cofrade · Cruz de IA';
  }, [route.page]);

  return (
    <ChallengeLayout>
      {route.page === 'new' && <CreateScreen />}
      {route.page === 'challenge' && <ChallengeScreen key={route.code} code={route.code} />}
      {route.page !== 'new' && route.page !== 'challenge' && (
        <div className="space-y-4">
          <Notice tone="error">Este enlace no es de ningún reto.</Notice>
          <a href="/reto/nuevo" className={primaryButton}>
            Crear un reto
          </a>
        </div>
      )}
    </ChallengeLayout>
  );
}
